import angular from 'angular';
import Popup from '../../../../common/services/popup';
import selectPeopleModalTemplateUrl from './select-people-popup.modal.ngtemplate.html';
import groupCallSelectPeople from './group-call-select-people/group-call-select-people';
class GroupCallSelectPeoplePopup extends Popup {
    constructor($rootScope, $modal) {
        super();
        this.$rootScope = $rootScope;
        this.$modal = $modal;
        this.templateUrl = '';
        this.contentTemplateUrl = selectPeopleModalTemplateUrl;
        this.backdrop = true;
    }
    open(data) {
        super.open(data);
    }
}
export default angular
    .module('doxy.common.services.groupCallSelectPeoplePopup', [
    groupCallSelectPeople,
])
    .service('groupCallSelectPeoplePopup', GroupCallSelectPeoplePopup).name;
